enum GalleryMenuEnum {
    GRAPHICS = "graphics",
    FINEART = "fineart",
    DRAWINGS = "drawings",
    SKETCH = "sketch"
}

export default GalleryMenuEnum;